export default {
  props: {
    comp__this: {
      type: Object,
      default: () => {}
    },
    active: {
      type: Boolean,
      default: false
    },
    baseConfig: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      base: {},
      data: [],
      viewData: null,
      styleMerge: {},
      itemStyleMerge: {}
    }
  },
  destroyed () {
    this.comp__this.unconstructor()
  },
  created () {
    // console.log('功能组件模版View',this)
  },
  watch: {
    baseConfig: {
      handler (nv) {
        this.comp__this.cssStyleHandel(this,'baseConfig')
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      // console.log('功能组件模版View-$nextTick',this)
      // VM绑定
      this.comp__this.viewNative(this)
    })
  },
  
}
